import { prop } from 'ramda';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useUserSelector } from 'js/store/hooks';

import * as actions from '../store/actions';
import { useJumioVerifyStatus } from './useJumioVerifyStatus';

export const useJumioVerifyStatusPopup = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const status = useJumioVerifyStatus();

    useEffect(() => {
        if (isLoggedIn && status) {
            dispatch(actions.showJumioVerifyStatusPopupAction({ status }));
        }
    }, [status, dispatch, isLoggedIn]);
};
